var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueInfoNudge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled / Info",
    clipPath: "url(#clip0_47305_81291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0.75C16.0228 0.75 20.5 5.22715 20.5 10.75C20.5 16.2728 16.0228 20.75 10.5 20.75C4.97715 20.75 0.5 16.2728 0.5 10.75C0.5 5.22715 4.97715 0.75 10.5 0.75ZM10.5 6.33973C10.9279 6.33973 11.2747 6.68655 11.2747 7.11439C11.2747 7.54222 10.9279 7.88904 10.5 7.88904C10.0722 7.88904 9.72536 7.54222 9.72536 7.11439C9.72536 6.68655 10.0722 6.33973 10.5 6.33973ZM11.1409 10.0954C11.1097 9.79256 10.8347 9.55572 10.5 9.55572C10.1444 9.55572 9.85618 9.82309 9.85618 10.1529V14.5631L9.85913 14.6206C9.89033 14.9234 10.1654 15.1603 10.5 15.1603C10.8556 15.1603 11.1439 14.8929 11.1439 14.5631V10.1529L11.1409 10.0954Z",
    fill: "#146EB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47305_81291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfoNudge);
export default __webpack_public_path__ + "static/media/blue-info-nudge.5a9b03242bc4acef9a749c652693ec22.svg";
export { ForwardRef as ReactComponent };